import { Link } from 'react-router';
import { RoutePaths } from '@shared/utils';
import { Button } from '@shared/widgets';

export const RecoveryResetPick = () => {
  return (
    <section className='flex flex-col gap-6'>
      <div className='text-center text-sm uppercase'>What do you need to recover:</div>
      <div className='flex flex-col gap-2.5'>
        <Link to={RoutePaths.recoveryUsername.onNavigate()}>
          <Button className='!h-[56px]' fullWidth>
            Recover username
          </Button>
        </Link>
        <Link to={RoutePaths.recoveryPassword.onNavigate()}>
          <Button className='!h-[56px]' fullWidth>
            Recover password
          </Button>
        </Link>
      </div>
      <Link to={RoutePaths.login.onNavigate()}>
        <Button className='h-[56px]' color='outlined' fullWidth>
          Cancel
        </Button>
      </Link>
    </section>
  );
};
